module.exports = __webpack_public_path__ + "static/media/futa.c4d3a2f2.png";